import "client-only";
import { fetcher } from "src/utils/fetcher";
import useSWR from "swr";
function useProdGroups(params) {
  return useSWR(
    {
      path: `/api/v1/product-groups`,
      method: "GET",
      params,
    },
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useProdGroups;
